import { render, staticRenderFns } from "./lefticon.vue?vue&type=template&id=1aebb2f6&scoped=true"
import script from "./lefticon.vue?vue&type=script&lang=js"
export * from "./lefticon.vue?vue&type=script&lang=js"
import style0 from "./lefticon.vue?vue&type=style&index=0&id=1aebb2f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aebb2f6",
  null
  
)

export default component.exports